import { render, staticRenderFns } from "./OpenningDueReceiptForm.vue?vue&type=template&id=54e97d0a"
import script from "./OpenningDueReceiptForm.vue?vue&type=script&lang=js"
export * from "./OpenningDueReceiptForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports